module.exports = __webpack_public_path__ + "media/James.e1f38c4f.mp3";